import { Component, OnInit } from '@angular/core';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { DocumentModel } from '../../../shared/models/document.model';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { AdjustEvent } from 'src/app/shared/services/external/adjust/adjust.service';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { callbackAdjustCA } from 'src/app/shared/constants/adjust-callback';

@Component({
  selector: 'app-financial-introduction',
  templateUrl: './financial-introduction.component.html',
  styleUrls: ['./financial-introduction.component.scss'],
})
export class FinancialIntroductionComponent implements OnInit {

  documentInfo: DocumentModel;

  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private navigationService: NavigationService,
    private abreCuentasService: AbreCuentasService,
    private adjustEvent: AdjustEvent) {
    // if (this.abreCuentasService.viewOptionMultiProduct) {
    this.headerService.show(false, false, true);
    // } else {
      // this.headerService.show();
    // }
  }

  ngOnInit() {
    const productSelected = this.abreCuentasService.getproductSelected();
    if (productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS) {
      const event = {
        eventToken: 'iqrkn4',
        callbackParams: callbackAdjustCA,
      };
      this.adjustEvent.adjustTrackEvent(event);
    }
    this.documentInfo = this.abreCuentasService.getDocumentInfo();
  }
  /**
   * Summary Continue with the next Step
   */
  next() {
    this.navigationService.nextStep();
  }

}
